import {Component, OnInit, Inject, HostListener} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {Utils} from '../../../../../../../common/services/Utils';
import {DictionaryService} from '../../../../../../shared/services/dictionary.service';
import {TranslateService} from '@ngx-translate/core';
import {SimpleObject} from '../../../../../../../common/dtos/SimpleObject';
import {ModuleENUM} from '../../../../../../../common/enums/module.enum';
import {Principal} from '../../../../../../../common/services/principal';

@Component({
  selector: 'app-add-parents-dialog',
  templateUrl: './add-parents-dialog.component.html',
  styleUrls: ['./add-parents-dialog.component.scss']
})
export class AddParentsDialogComponent implements OnInit {
  citizenshipList = [];
  has_iin_items: SimpleObject[];
  isTechSecretary = false;

  constructor(public dialogRef: MatDialogRef<AddParentsDialogComponent>,
              private _utils: Utils, private _dictionaryService: DictionaryService,
              public _translateService: TranslateService,
              private _principal: Principal,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.isTechSecretary = _principal.getAccessByModuleId(ModuleENUM.ENROLLE);
    if (!data.citizenship) {
      this.data.citizenship =  113;
    }
  }

  ngOnInit() {
    this._dictionaryService.getCitizenshipList().subscribe(data => {
        this.citizenshipList = this._utils.translateListWithSort(data, 'name');
      }, err => { console.log('EnrollCabinetComponent _dictionaryService.getCitizenshipList() error', err);
        this._utils.notifyError(this._translateService.instant('error_occurred'), '');
      }
    );
    this.getHasIINitems();
  }

  @HostListener('keydown.esc')
  public onEsc() {
    this.dialogRef.close();
  }
  getHasIINitems() {
    this.has_iin_items = new Array();
    this.has_iin_items.push(new SimpleObject(1,'Имеется'));
    this.has_iin_items.push(new SimpleObject(0,'Нет'));
  }

  close(): void {
    this.dialogRef.close();
  }

  onSubmit(valid): void {
    if ((this.data.citizenship === 113 || this.data.has_iin === 1) && this.data.iin.length != 12 && !this.isTechSecretary) {
      this._utils.notifyError(this._translateService.instant('iin_input_error'), '');
      valid = false;
    }
    if (!valid) {
      return;
    }
    this.dialogRef.close(this.data);
  }

  citizenshipChanged() {
    if (this.data.citizenship === 113) {
      this.data.has_iin = 1;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/components/enroll-cabinet/tabs/enroll-personal-info/add-parents-dialog/add-parents-dialog.component.ts